export default __webpack_public_path__ + "static/media/Calender.df776324.svg";